module.exports = __webpack_public_path__ + "static/internalfinishes-1895bcb86347b4248aef62034151daff.jpg";